// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"107":"2cbb45fc","152":"c4ba3a14","281":"d423db6d","771":"aa1de25a","825":"a1e4cb16","887":"0a2134c0","992":"3bcde1d9"}[chunkId] + ".chunk.css";
};